<apiz-grid-headless
  #grid
  class="apiz-grid-headless"
  [border]="!isTabTopLevel"
  [cacheRowCount]="cacheBlockSize"
  [columnDefs]="columnsTableHeader"
  [components]="data.frameworkComponents"
  [getContextMenuItems]="getContextMenuItems"
  [initAutosizeBehavior]="initAutosizeBehavior"
  [maxCacheRowCount]="cacheBlockSize"
  [mergedPanels]="!isTabTopLevel || isOneColumn || isMobile"
  [pagination]="pagination"
  [paginationPageCountOption]="isTabTopLevel ? 'AUTO' : paginationPageSize ? paginationPageSize : 10"
  [paginationPageCountOptions]="paginationOption"
  [rowMultiSelectWithClick]="rowMultiSelectWithClick"
  [rowSelection]="rowSelection"
  [rowSelectionOnCellClicked]="!suppressRowClickSelection"
  (allSelected)="onRowSelected($event)"
  (cellClicked)="onCellClicked($event)"
  (dataStateChanged)="onDataStateChanged($event)"
  (gridReady)="onGridReady($event)"
  (pageChanged)="onPageChange()"
  (rowSelected)="onRowSelected($event)">
  @if (data.isHighVolume) {
    <div azProjectAs="empty-overlay" class="apiz-gridtab-empty-overlay">
      <i class="az-filter"></i>
      <span class="main-reason"> {{ 'grid.empty-high-volume.main' | translate }}</span>
      <span class="reason-description">{{ 'grid.empty-high-volume.description' | translate }}</span>
    </div>
  } @else {
    <div azProjectAs="empty-overlay" class="apiz-gridtab-empty-overlay apiz-gridtab-empty-overlay-default">
      @if (api.filters()?.length) {
        <!-- the filters hide every row: say so and offer to clear them -->
        <span class="reason-description">{{ 'grid.empty.filtered' | translate }}</span>
        <button type="button" class="apiz-gridtab-overlay-action" (click)="clearFilters()">
          <i class="icon-close" aria-hidden="true"></i>
          {{ 'grid.empty.clearFilters' | translate }}
        </button>
      } @else {
        <span class="reason-description">{{ 'grid.empty.main' | translate }}</span>
      }
    </div>
  }
  <!-- loading failed: message and retry instead of the generic error text -->
  <div azProjectAs="error-overlay" class="apiz-gridtab-empty-overlay apiz-gridtab-error-overlay" role="alert">
    <span class="reason-description">{{ 'grid.error.loadFailed' | translate }}</span>
    <button type="button" class="apiz-gridtab-overlay-action" (click)="retryLoad()">
      <i class="icon-refresh" aria-hidden="true"></i>
      {{ 'grid.error.retry' | translate }}
    </button>
  </div>
</apiz-grid-headless>
